import {Button, Col, Form} from 'react-bootstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import React from 'react'
import Row from 'react-bootstrap/Row'

import Count from '../../ui/page/Count'
import Field from '../../ui/form/Field'

interface CatalogueFiltersInterface {
    handleCancel: Function;
    handleSearchInput: Function;
    handleSearch: Function;
    searchInput: {
        nom: string,
        tel: string,
    };
    totalItems: number;
}

const CatalogueFilters = ({
    handleSearch,
    searchInput,
    handleSearchInput,
    handleCancel,
    totalItems,
}: CatalogueFiltersInterface) => {
    return (
        <Col
            xs={12}
            className="filter d-flex flex-row flex-wrap align-items-center justify-content-between">
            <Form onSubmit={handleSearch}>
                <Row className={'mt-2'}>
                    <Col>
                        <div className="form-label mr-4 mb-1">Nom :</div>
                        <Field
                            name="nom"
                            placeholder="Nom"
                            classNames="mb-3 mr-2"
                            value={searchInput.nom}
                            onChange={handleSearchInput}
                        />
                    </Col>
                    <Col>
                        <div className="form-label mr-4 mb-1">Téléphone :</div>
                        <Field
                            name="tel"
                            placeholder="Téléphone"
                            classNames="mb-3 mr-2"
                            value={searchInput.tel}
                            onChange={handleSearchInput}
                        />
                    </Col>
                    <Col className={'d-flex align-items-end'}>
                        <Button
                            type="submit"
                            className="btn-primary btn-square d-flex align-items-center mb-3 mr-2"
                            disabled={
                                searchInput.nom === '' && searchInput.tel === ''
                            }>
                            <FontAwesomeIcon icon="search" color="white" />
                        </Button>
                        <Button
                            className="btn-red btn-square d-flex align-items-center mb-3"
                            onClick={handleCancel}
                            disabled={
                                searchInput.nom === '' && searchInput.tel === ''
                            }>
                            <FontAwesomeIcon
                                icon="times"
                                color="white"
                                style={{marginLeft: '2px', marginRight: '2px'}}
                            />
                        </Button>
                    </Col>
                </Row>
            </Form>

            <div className="d-flex align-self-end mb-3">
                <Count totalItems={totalItems} name="client" />
            </div>
        </Col>
    )
}

export default CatalogueFilters
